import type TriggerEngine from "../../TriggerEngine";

import type { EventSourceResult } from "../../TriggerEngine.interfaces";

import { wireStreamingEvents } from "./streaming.source";

import { wireSceneEvents } from "./scene.source";

import { wirePlaylistEvents } from "./playlist.source";

import { wireMicEvents } from "./mic.source";

import { wireTimerEvents } from "./timer.source";

import { wireScheduledEvents } from "./scheduled.source";

import { wireHotkeyEvents } from "./hotkey.source";

import { wireEventBusEvents } from "./eventBus.source";

export type EventSourceWireFn =
  | ((engine: TriggerEngine) => EventSourceResult)
  | ((engine: TriggerEngine) => Promise<EventSourceResult>);

export const EVENT_SOURCE_MAP: Record<string, EventSourceWireFn> = {
  stream_started: wireStreamingEvents,

  stream_stopped: wireStreamingEvents,

  scene_switched: wireSceneEvents,

  track_ended: wirePlaylistEvents,

  playlist_started: wirePlaylistEvents,

  playlist_stopped: wirePlaylistEvents,

  playlist_ended: wirePlaylistEvents,

  mic_muted: wireMicEvents,

  mic_unmuted: wireMicEvents,

  timer_reached: wireTimerEvents,

  scheduled: wireScheduledEvents,

  hotkey: wireHotkeyEvents,

  event_follow: wireEventBusEvents,

  event_sub: wireEventBusEvents,

  event_donation: wireEventBusEvents,

  event_raid: wireEventBusEvents,

  event_chat: wireEventBusEvents,
};

export {
  wireStreamingEvents,
  wireSceneEvents,
  wirePlaylistEvents,
  wireMicEvents,
  wireTimerEvents,
  wireScheduledEvents,
  wireHotkeyEvents,
  wireEventBusEvents,
};
